import React from "react";
import {
  ActiveFilterChips,
  DataTable,
  InlineFilters,
  ListPageHeader,
  ListSearchForm,
  SearchToolbar,
  TablePagination,
  formatResultCount,
} from "../../common/DataList";
import usePersistedState from "../../Hooks/usePersistedState/usePersistedState";
import RecipientListFilters from "./RecipientListFilters";
import useRecipientList from "./useRecipientList";

export const FILTERS_PANEL_ID = "recipient-list-filters";
const FILTERS_OPEN_KEY = "espoar.boa.recipientList.filtersOpen";
const COUNT_LABELS = {
  none: "Aucun allocataire trouvé",
  one: "allocataire trouvé",
  many: "allocataires trouvés",
};

const RecipientList = () => {
  const list = useRecipientList();
  const [filtersOpen, setFiltersOpen] = usePersistedState(FILTERS_OPEN_KEY, true);

  return (
    <div className="container-fluid px-5 my-5 list-page">
      <ListPageHeader
        title="Allocataires"
        action={{
          to: "/recipients-create",
          text: "Créer un allocataire",
          dataPriv: "create_recipient",
        }}
      />

      <ListSearchForm onSubmit={list.submit} aria-label="Recherche d'allocataires">
        <SearchToolbar
          id="recipient-search"
          name="terms"
          value={list.filters.terms}
          onChange={list.onFilterChange}
          placeholder="Nom, prénom, email, téléphone, NIR, matricule…"
          hint="NIR et matricule : saisir la valeur complète."
          isLoading={list.isLoading}
          isDirty={list.isDirty}
          inlineFilters={
            <InlineFilters
              definitions={list.principalFilters}
              filters={list.filters}
              onChange={list.onFilterChange}
              onSet={list.setFilter}
            />
          }
          filtersLabel="Plus de filtres"
          filtersPanelId={FILTERS_PANEL_ID}
          filtersOpen={filtersOpen}
          onToggleFilters={() => setFiltersOpen((open) => !open)}
          activeFiltersCount={list.panelActiveFiltersCount}
        />
        <ActiveFilterChips
          chips={list.chips}
          onRemove={list.removeFilter}
          onClear={list.resetFilters}
        />
        <RecipientListFilters
          id={FILTERS_PANEL_ID}
          open={filtersOpen}
          groups={list.groups}
          filters={list.filters}
          onChange={list.onFilterChange}
          onSet={list.setFilter}
          onReset={list.resetFilters}
          canReset={list.canReset}
        />
      </ListSearchForm>

      <section className="list-card" aria-label="Résultats">
        <div className="results-bar">
          <p className="results-bar__count" role="status" aria-live="polite">
            {list.hasSearched ? formatResultCount(list.count, COUNT_LABELS) : "Aucune recherche lancée"}
          </p>
        </div>
        <DataTable
          caption="Liste des allocataires"
          columns={list.columns}
          rows={list.items}
          rowKey="id"
          isLoading={list.isLoading}
          hasSearched={list.hasSearched}
          error={list.error}
          emptyState={{
            title: "Aucun allocataire ne correspond à ces critères",
            hint: "Modifiez votre recherche ou vos filtres.",
            action: list.canReset
              ? { label: "Réinitialiser les filtres", onClick: list.resetFilters }
              : null,
          }}
        />
        <TablePagination
          page={list.page}
          nbPages={list.nbPages}
          count={list.count}
          nbItemsByPage={list.nbItemsByPage}
          onChangePage={list.changePage}
          onChangeNbItemsByPage={list.changeNbItemsByPage}
          itemLabel="allocataires"
        />
      </section>
    </div>
  );
};

export default RecipientList;
